










import { Components } from '@empathybroker/ebx-gluon';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Sort: Components.Smart.Sort
  }
})
export default class GoccoFacetsHeader extends Vue {

}
